<template>
  <div class="industry-title">
    {{title}}
    <p class="subtitle">{{info}}</p>
  </div>
</template>
<script>
export default {
     props: {
        title: {
            type: String,
            default: "solutions"
        },
        info:{
            type:String,
            default: "工业机器人零部件解决方案"
        }
    },
};
</script>

<style scoped>
.industry-title {
  position: relative;
  text-align: center;
  letter-spacing: 5px;
  text-transform: uppercase;
  color: rgba(38, 85, 173, 0.1);
  font-size: 60px;
  font-weight: 700;
  line-height: 1.4;
}
.industry-title p {
  position: absolute;
  font-size: 30px;
  text-align: center;
  letter-spacing: 2px;
  color: #2655ad;
  width: 100%;
  top: 32px;
  left: 0;
  font-weight: 500;
}
</style>


// WEBPACK FOOTER //
// src/components/industry/IndustryTitle.vue